const MESSAGES = {
  confirm_promote_favorites: {
    title: "Confirm Promotion of Sandbox",
    message:
      "Please confirm that you would like to promote the Sandbox items to Live. " +
      "This will take effect immediately. ",
  },
  confirm_generate_favorites: {
    title: "Confirm Generation of Popular Items",
    message:
      "The system will review all the orders made in the last 3 months and generate the top 1000 most popular items. " +
      "The newly generated items will be placed under the review folder. " +
      "Please confirm that you would like to proceed.",
  },
  promote_favorites_successful: {
    title: "Popular Products Now Live",
    message:
      "You have successfully move the popular items from sandbox to prodution.",
  },
  promote_favorites_error: {
    title: "Error Promoting Sandbox",
    message: "Cannot promote popular items from sandbox to production.",
  },
  confirm_delete_favorites: {
    title: "Confirm Clear",
    message: "Are you sure you want to clear all the products in Review List?",
  },
  //
  no_branch_access: {
    message:
      "You don't have branch access.  Please ask your administrator to double check your access rights.",
  },
};

export const getTitle = (key) => {
  return MESSAGES[key] ? MESSAGES[key].title : "No Title Found";
};

export const getMessage = (key) => {
  return MESSAGES[key] ? MESSAGES[key].message : `No Message Found ${key}`;
};
